/* tslint:disable */
/* eslint-disable */
/**
 * Mclarens.OutlookAddin.Api.WebApi | v1
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface SiteVisitDetailsResponse
 */
export interface SiteVisitDetailsResponse {
    /**
     * 
     * @type {string}
     * @memberof SiteVisitDetailsResponse
     */
    claimNumber: string;
    /**
     * 
     * @type {Date}
     * @memberof SiteVisitDetailsResponse
     */
    siteVisitDate: Date;
}

/**
 * Check if a given object implements the SiteVisitDetailsResponse interface.
 */
export function instanceOfSiteVisitDetailsResponse(value: object): value is SiteVisitDetailsResponse {
    if (!('claimNumber' in value) || value['claimNumber'] === undefined) return false;
    if (!('siteVisitDate' in value) || value['siteVisitDate'] === undefined) return false;
    return true;
}

export function SiteVisitDetailsResponseFromJSON(json: any): SiteVisitDetailsResponse {
    return SiteVisitDetailsResponseFromJSONTyped(json, false);
}

export function SiteVisitDetailsResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): SiteVisitDetailsResponse {
    if (json == null) {
        return json;
    }
    return {
        
        'claimNumber': json['claimNumber'],
        'siteVisitDate': (new Date(json['siteVisitDate'])),
    };
}

export function SiteVisitDetailsResponseToJSON(value?: SiteVisitDetailsResponse | null): any {
    if (value == null) {
        return value;
    }
    return {
        
        'claimNumber': value['claimNumber'],
        'siteVisitDate': ((value['siteVisitDate']).toISOString().substring(0,10)),
    };
}

